import { cn } from '@/lib/utils';

export function BrandWordmark({
  className,
  compact = false,
}: {
  className?: string;
  compact?: boolean;
}) {
  if (compact) {
    return (
      <span
        aria-label="Kalonmoves Business"
        className={cn(
          'font-brand text-h3 leading-none tracking-[0.04em] text-foreground',
          className,
        )}
        role="img"
      >
        <span aria-hidden="true">K</span>
      </span>
    );
  }

  return (
    <span
      aria-label="Kalonmoves Business"
      className={cn('inline-flex min-w-0 flex-col items-start font-brand', className)}
      role="img"
    >
      <span
        aria-hidden="true"
        className="block text-meta leading-none tracking-[0.12em] text-foreground"
      >
        KALONMOVES
      </span>
      <span
        aria-hidden="true"
        className="mt-1 block text-micro leading-none tracking-[0.32em] text-muted-foreground"
      >
        BUSINESS
      </span>
    </span>
  );
}
